export interface Product {
  Name: string;
  ProductCode: string;
  Upc: string;
  UpcOrCode: string;
  Price: number;
  OriginalPrice: number;
  ProductId: number;
  VendorId: number;
  AttributeOptions: ProductAttribute[];
  Images: Image[];
  DisplayTheme?: string;
  IsActive: boolean;
}

export type AttributeSelectionType = "select" | "button" | "fancy" | "";

export interface ProductAttribute {
  Name: string;
  Options: AttributeOption[];
  Id: number;
  IsRequired: boolean;
  Type: AttributeType;
  DisplayType: AttributeSelectionType;
  DisplayZero?: string;
  DisplayOrder: number;
}

export enum AttributePriceType {
  Same = 0,
  Add = 1,
  Subtract = 2,
  Override = 3,
}
export interface PriceAdjustment {
  Price: number;
  PriceType: AttributePriceType;
}
export interface AttributeOption {
  Name: string;
  Price: number;
  PriceType: AttributePriceType;
  Upc: any;
  AttributeId: number;
  Id: number;
  IconUrl?: string;
  Priority: number;
  Description?: string;
}
export enum AttributeType {
  Selection = 0,
  Custom = 1,
}
export interface Image {
  Url: string;
  Size: string;
}
export interface ProductSelectionModel {
  Name: string;
  ProductCode: string;
  Price: number;
  ProductId: number;
  OriginalPrice: number;
  Attributes: Array<SelectedAttribute>;
}
export interface ProductCartModel extends ProductSelectionModel {
  Quantity: number;
}

type SelectedAttribute = {
  Name: string;
  AttributeId: number;
  DetailId: number;
};
